import React from 'react';
import { theme } from '@/styles/theme';
import { Edit, Delete, RestoreFromTrash } from '@mui/icons-material';
import { Stack, Tooltip, IconButton } from '@mui/material';
import { Can } from '@/components/common';

interface IUnitsTableActionsProps {
  id: string;
  deletedAt?: string;
  // eslint-disable-next-line no-unused-vars
  onEditUnit: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onDeleteUnit: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onRestoreUnit: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onEditUnitMouseEnter: (id: string) => void;
}

export function UnitsTableActions({
  id,
  deletedAt,
  onEditUnit,
  onDeleteUnit,
  onRestoreUnit,
  onEditUnitMouseEnter,
}: IUnitsTableActionsProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="center"
    >
      <Can permissions={['units_update']}>
        <Tooltip title="Alterar" disableInteractive>
          <IconButton
            onMouseEnter={() => onEditUnitMouseEnter(id)}
            onClick={() => onEditUnit(id)}
            size="small"
            sx={{
              '&:hover': {
                color: theme.palette.primary.main,
              },
            }}
          >
            <Edit fontSize="small" />
          </IconButton>
        </Tooltip>
      </Can>
      {deletedAt ? (
        <Can permissions={['units_restore']}>
          <Tooltip title="Restaurar" disableInteractive>
            <IconButton
              onClick={() => onRestoreUnit(id)}
              size="small"
              sx={{
                '&:hover': {
                  color: theme.palette.primary.main,
                },
              }}
            >
              <RestoreFromTrash fontSize="small" />
            </IconButton>
          </Tooltip>
        </Can>
      ) : (
        <Can permissions={['units_delete']}>
          <Tooltip title="Excluir" disableInteractive>
            <IconButton
              onClick={() => onDeleteUnit(id)}
              size="small"
              sx={{
                '&:hover': {
                  color: theme.palette.error.main,
                },
              }}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </Can>
      )}
    </Stack>
  );
}
